export default function RedesSocialesMenu({ idioma }) {
  return (
    <iframe
      src={
        idioma === 'es'
          ? 'https://docs.terramarbrandsusa.com/legales/Lineamientos_de_publicaciones_ESP.pdf'
          : 'https://docs.terramarbrandsusa.com/legales/Lineamientos_de_publicaciones_ING.pdf'
      }
      style={{ width: '100%', height: '100%' }}
      frameBorder='0'
      title='framelegales'
    />
  );
}
